import {
  FilmSlate, DeviceMobile, FrameCorners,
  ShareNetwork, Sparkle, MagicWand,
} from "@phosphor-icons/react";
import { Reveal, SectionHeading } from "./Reveal";
import { SERVICES } from "@/data/content";

const ICONS = { FilmSlate, DeviceMobile, FrameCorners, ShareNetwork, Sparkle, MagicWand };

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative py-28 md:py-44">
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[400px] glow-gold blur-[120px] opacity-40 pointer-events-none" />
      <div className="max-w-[88rem] mx-auto px-6 md:px-10 relative">
        <SectionHeading chapter="02" overline="Services" title="What I Create" />

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-testid="services-grid">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <Reveal key={s.title} delay={0.06 * (i % 3)}>
                <div
                  data-testid={`service-card-${i}`}
                  className="group relative h-full rounded-2xl border border-white/[0.08] bg-surface p-8 md:p-10 hover:border-gold/40 hover:-translate-y-1 transition-[border-color,transform] duration-500"
                >
                  <div className="mb-8 inline-flex items-center justify-center h-14 w-14 rounded-xl bg-gold/10 text-gold group-hover:bg-gold group-hover:text-void transition-colors duration-500">
                    <Icon size={28} weight="duotone" />
                  </div>
                  <h3 className="font-display text-xl md:text-2xl font-semibold text-zinc-50">{s.title}</h3>
                  <p className="mt-4 text-sm md:text-[15px] text-zinc-500 leading-relaxed">{s.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
